<div class="search-form-container {{containerClass}}">
  <button
    class="search-form-button {{searchButtonClass}}"
    color="primary"
    mat-flat-button
    [type]="typeSearch"
    [disabled]="disabled"
    (click)="handleSearch()">
    <mat-icon *ngIf="showIconSearch">search</mat-icon>
    {{textSearch}}
  </button>

  <button
    class="search-form-button {{clearButtonClass}}"
    color="primary"
    type="button"
    mat-stroked-button
    [disabled]="disabled"
    (click)="handleClear()">
    Limpiar
  </button>
</div>
